import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '@/lib/axios'
import { KpiWidget } from './KpiWidget'

export function KpiOrdiniInAttesaWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<number>({
    queryKey: ['dashboard', 'ordini-in-attesa-count'],
    queryFn: async () => {
      const res = await axiosInstance.get('/purchase-requests/count', {
        params: { stato_nome: 'Ordinata' },
      })
      return res.data?.count ?? 0
    },
    staleTime: 30000,
  })
  return (
    <KpiWidget
      title="Ordini in attesa"
      value={data}
      loading={isLoading}
      color="#722ed1"
      onClick={() => navigate('/ordini')}
    />
  )
}
